import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import EconDropdown from "../../../../ui-kit/EconDropdown/EconDropdown";
import _ from "lodash";

import {FC, Suspense, useCallback, useEffect, useMemo, useRef, useState } from "react";
import {useIntl} from 'react-intl'
import {Link, Outlet, useLocation, useSearchParams} from 'react-router-dom'
import { PageTitle, PageDataProvider, useLayout } from "../../../../_metronic/layout/core";
import {HeaderWrapper} from '../../../../_metronic/layout/components/header'
import {ScrollTop} from '../../../../_metronic/layout/components/scroll-top'
import {Content} from '../../../../_metronic/layout/components/content'
import {FooterWrapper} from '../../../../_metronic/layout/components/footer'
import {ToolbarWrapper} from '../../../../_metronic/layout/components/toolbar'
import { Row, Col, Card, Navbar, Image, Button, Form } from 'react-bootstrap'
import clsx from "clsx";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { Header } from "../../../../_metronic/layout/components/header/Header";
import ProductGroupDropdown from "./components/ProductGroupDropdown";
import TradePartnerDropdown from "./components/TradePartnerDropdown";
import { CommodityLineChartCard } from "./components/CommodityLineChartCard";
import { useLoading } from "../../../contexts/LoadingContext";
import { TopPartnerChartCard } from "./components/TopPartnerChartCard";
import { TopCommodityTableCard } from "./components/TopCommodityTableCard";
import { EmailIcon, EmailShareButton, FacebookIcon, FacebookShareButton, LinkedinIcon, LinkedinShareButton, XIcon, TwitterShareButton, WhatsappIcon, WhatsappShareButton } from "react-share";
import { CommodityDetailModal } from "./components/CommodityDetailModal";
import { getCommodities, getListTradePartnerByCommodity, getProductGroups } from "./core/_request";
import MultiTagDropdown from "../../../../ui-kit/MultiTagDropdown/MultiTagDropdown";
import CustomDropdown from "../../../../ui-kit/Dropdown";
import { all } from "axios";
import { ByProductLineChartCard } from "./components/ByProductLineChartCard";
import { Toast } from "../../../../ui-kit";

type Category = {
  id: number;
  name: string;
  code?: string | null;
  category_type?: string | null;
  parent_id?: number | null;
  sub_category?: Category[];
};

type TreeNode = {
  label: string;
  value: string | number;
  checked?: boolean;
  children?: TreeNode[];
};

const convertToTree = (data: Category[], initialData: number[] | null = []): TreeNode[] => {
  
  return _.map(data, (item) => {
    return {
      label: item.name,
      value: item.id, // fallback to id if code is null
      checked: initialData && (initialData.includes(item.id)),
      children: item.sub_category && item.sub_category.length
        ? convertToTree(item.sub_category, initialData)
        : undefined,
    }
  });
};

const WEFDashboardPage: FC =  () => {
  const intl = useIntl()
  const loadingContext = useLoading();
  const {config, classes} = useLayout()
  const selectHsVerRef = useRef<HTMLSelectElement>(null);
  
  const [searchParams, setSearchParams] = useSearchParams();
  
  const productGroupParams = searchParams.get('product_group');
  const rep = searchParams.get('rep');
  const par = searchParams.get('par');
  const flow = searchParams.get('tradeflow');
  // const hsVersion = searchParams.get('hs_ver');
  
  const [localParams, setLocalParams] = useState<any>({});
  const [rawProductGroups, setRawProductGroups] = useState<any[]>([]);
  const [productGroups, setProductGroups] = useState<any[]>([]);
  const [requestParams, setRequestParams] = useState<any>({})
  const [modalParam, setModalParam] = useState({
    show: false,
    commodity: '',
    description:'',
    rep:rep || 'ASEAN',
    // par:par || 'WLD',
    type:'', // chart or table
    commodityData:{},
    product_group:1,
    year:'',
    tradeflow:flow || 'exports',
    // hs_ver:hsVersion || 'H5'
  });

  const isDisabled = loadingContext?.getCount ? loadingContext.getCount() > 0 : false;
  const shareUrl =  window.location.href;
  const title = "Share this Page"

  const handleToggleModal = () =>{
    setModalParam((prev)=>{
      if(!prev.show===false){
        //Reset Modal
        return{
          ...prev,
          show: !modalParam.show,
          description:'',
          commodity: '',
          partner:'',
          type: '',
          commodityData:[],
          year:'',
          tradeflow:'imports'
        }
      }
      return{
        ...prev,
        show: !modalParam.show
      }
    })
  }

  const handleTreeChange = useCallback((selectedNodes) => {
    setProductGroups((tree) => {
      const selectedNodesValues = new Set(selectedNodes.map((e) => e.value));
      function recursiveFindAndUpdateTree(nodes) {
        if (!nodes || nodes.length === 0) return;
        nodes.forEach((e) => {
          e.checked = selectedNodesValues.has(e.value);
          recursiveFindAndUpdateTree(e.children);
        });
      }
      recursiveFindAndUpdateTree(tree);
      return tree;
    });

    setLocalParams((prev) => ({
      ...prev,
      product_group: selectedNodes.map((e) => e.value),
    }));
  }, []);

  const handleCommoditySelected = (
      hs:string, 
      year:number, 
      tradeflow:string, 
      hsList:string|null,
      description: string
    ) =>{  
      handleToggleModal()
      getListTradePartnerByCommodity({
        rep:requestParams.rep,
        hs: hsList!=='-'?hsList?.replaceAll(';', ','):hs,
        product_group: requestParams.product_group?.join(',') || '21,22',
        year,
        tradeflow
      }).then((res)=>{
        const tradeData = {
          count: res.data.length,
          rows: res.data
        }
        setModalParam((prev)=>{
          return{
            ...prev,
            show: true,
            commodity: hs,
            description:description,
            type: 'chart',
            commodityData: tradeData,
            year:year.toString(),
            tradeflow,
            product_group: requestParams.product_group,
          }
        })     
      }).catch((err)=>{
        console.error(err)
      })
    }
  
  const handleTopCountrySelected = (rep:string, par:string, year:number, tradeflow:string) =>{
    if(par){   
      handleToggleModal()
      getCommodities({
        rep,
        par,
        tradeflow,
        year,
        productGroup: requestParams.product_group?.join(',') || '21,22',
      }).then((res)=>{
        const tradeData = res.data.data
        setModalParam((prev)=>{
        return{
            ...prev,
            show: true,
            commodity: '',
            partner: par,
            type: 'table',
            commodityData: tradeData,
            year:year.toString(),
            tradeflow,
            product_group: requestParams.product_group,
          }
        })     
      }).catch((err)=>{
        console.error(err)
      })
    }
  }
  
  const handleInputChange = (field: any, value:any) =>{
    // const hsVersion = selectHsVerRef.current?.value;
    setLocalParams(prev=>{
      return {
        ...prev,
        // 'hs_ver':hsVersion,
        [field]:value
      }
    })
  }

  const handleApply = () =>{
    if(localParams.product_group==null || localParams.product_group.length===0){
      Toast(
        'Invalid Data',
        'info',
        'Please select at least one Product Group'
      )
      return
    }

    if(isDisabled){
      Toast(
        'Warning',
        'info',
        'Still processing, please wait...'
      )
      return
    }
    setRequestParams(prev=>({
      ...prev,
      ...localParams
    }))    
    setSearchParams({
      ...localParams,
      product_group: localParams.product_group?.join(','),
    })
  }

  useEffect(()=>{
    //Get Product Group
    getProductGroups({type:'wef'}).then((res)=>{
      const resultsProductGroup = res.data.data
      const initialParams = {
        product_group: productGroupParams?productGroupParams.split(','): [22,21],
        rep:rep || 'ASEAN',
        tradeflow:flow || 'exports',
      }
      setLocalParams(initialParams)
      setRawProductGroups(resultsProductGroup)
      const treeData = convertToTree(resultsProductGroup,initialParams.product_group.map(Number) || [22,21])
      setProductGroups(treeData)
      setRequestParams(prev=>({
        ...prev,
        ...initialParams
      }))
    }).catch((err)=>{
      console.error(err)
    })
  },[])

  return (
    <>
      <PageDataProvider>        
        {/* <PageTitle breadcrumbs={[]}>Trade in Plastic-based products Dashboard</PageTitle> */}
        <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
          <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
            {/* Header Wrapper */}
            <div id='kt_app_header' className='app-header'>
              <div
                id='kt_app_header_container'
                className={clsx(
                  'app-container flex-lg-grow-1',
                  classes.headerContainer.join(' '),
                  config.app?.header?.default?.containerClass
                )}
              >
              <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15'>
                <Link to='/'>
                  <>
                    <img
                      alt='Logo'
                      src={toAbsoluteUrl('/media/logos/default.svg')}
                      className='h-20px h-lg-30px app-sidebar-logo-default theme-light-show'
                    />
                  </>
                </Link>
                <img
                      alt='Logo'
                      src={toAbsoluteUrl('/media/logos/WEF.png')}
                      className='h-50px h-lg-50px app-sidebar-logo-default theme-light-show ms-2'
                    />
                <img
                      alt='Logo'
                      src={toAbsoluteUrl('/media/logos/da15.png')}
                      className='h-50px h-lg-50px app-sidebar-logo-default theme-light-show ms-2'
                    />
              </div>
              <div
                id='kt_app_header_wrapper'
                className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'
              >
                    <div
                      className='app-header-menu app-header-mobile-drawer align-items-stretch'
                      data-kt-drawer='true'
                      data-kt-drawer-name='app-header-menu'
                      data-kt-drawer-activate='{default: true, lg: false}'
                      data-kt-drawer-overlay='true'
                      data-kt-drawer-width='225px'
                      data-kt-drawer-direction='end'
                      data-kt-drawer-toggle='#kt_app_header_menu_toggle'
                      data-kt-swapper='true'
                      data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
                      data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
                    >
                      <Header />
                    </div>
                <Navbar />
              </div>
            </div>
          </div>
            {/* End Header Wrapper */}
            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
              <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                <div className='d-flex flex-column flex-column-fluid'>
                  <ToolbarWrapper />
                  <Content>    
                    <Row className='mb-5'>
                      <Col>
                        <Card className='card-custom card-border'>
                          <Card.Body className='d-flex justify-content-around align-items-center'>
                            <Image src='/media/tina/img-result-documents.jpg' thumbnail width={110} />
                            <div className='ms-5 d-flex flex-column justify-content-center'>
                              <h3 className='text-primary'>Trade Policy for Plastics Circularity in ASEAN Dashboard</h3>
                              <div className='text-gray-700'>
                                This interactive dashboard is made to complement <a href="https://www.globalplasticaction.org/case-study-details/trade-policy-and-plastics-circularity:-regional-action-in-asean/aJYTG0000001A294AE" target="_blank" rel="noopener noreferrer">“Trade Policy for Plastics Circularity: Leveraging Regional Action in ASEAN.”</a> It presents plastics-related trade flows for ASEAN member states, enabling detailed exploration of regional trade patterns. Plastic trade flows are classified using UNCTAD’s framework into five life-cycle categories: primary plastics, intermediate forms of plastics, intermediate manufactured plastic products, final manufactured plastic products, and plastic waste. In addition, two categories of “associated” trade flows are included - feedstocks and additives used in plastics production - reflecting their role across the plastics life cycle. Non-plastic substitutes are also incorporated, as they contribute to enhancing circularity and enabling more sustainable material use.
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>                
                    <Row className='mb-5'>
                      <Col>
                        <Card>
                          <Card.Header className='card-header-stretch'>
                            <Card.Title className='w-100 me-0'>
                              <div className='title-container w-100 d-flex justify-content-between align-items-center px-0'>
                                <div className='title d-flex align-items-center'>
                                  <span className='fa fa-gears px-2'></span>
                                  <h3 className='text-gray-700'>Settings</h3>
                                </div>
                              </div>
                            </Card.Title>
                          </Card.Header>
                          <Card.Body>
                            <Row>
                              <Col md={4} className='mb-5'>
                                Product Group(s):
                                {/* <ProductGroupDropdown onSelect={(productGroup)=>handleInputChange('product_group',productGroup)}/> */}
                                <MultiTagDropdown
                                  id="product-group-dropdown"
                                  data={productGroups}
                                  onChange={handleTreeChange}
                                  // disabled={isDisabled}
                                />
                              </Col>
                              <Col md={4} className='mb-5'>
                                Economy:
                                <TradePartnerDropdown 
                                  onSelect={(econ)=>handleInputChange('rep',econ)}
                                  defaultEcon={rep || 'ASEAN'}
                                  role='rep'
                                  />
                              </Col>
                              {/* <Col md={3} className='mb-5 d-none'>
                                Partner:
                                <TradePartnerDropdown 
                                  onSelect={(econ)=>handleInputChange('par',econ)}
                                  defaultEcon={par || 'WLD'}
                                  role='par'
                                  />
                              </Col> */}
                              <Col md={4} className='mb-5'>
                                Trade flow:
                                <CustomDropdown
                                  placeholder="Select Flow"
                                  searchable={false}
                                  items={[
                                    { label: 'Imports', value: 'imports' },
                                    { label: 'Exports', value: 'exports' }
                                  ]}
                                  getLabel={(e) => e.label}
                                  getKey={(e) => e.value}
                                  value={[
                                    { label: 'Imports', value: 'imports' },
                                    { label: 'Exports', value: 'exports' }
                                  ].find(f=>f.value=== (localParams.tradeflow || flow || 'exports'))}
                                  onSelect={(e) => handleInputChange('tradeflow', e.value)} />
                              </Col>
                            </Row>
                            <Row className='mb-5 justify-content-end'>
                              <Col xs='auto'>
                                <Button variant="outline-primary" size="sm" className='d-flex gap-2 align-items-center' onClick={handleApply} disabled={isDisabled}>
                                  {isDisabled ? (
                                    <>
                                      <span className="spinner-border spinner-border-sm align-middle" role="status" aria-hidden="true"></span>Processing
                                    </>
                                  ) : (
                                    <>
                                      <span className='fa fa-search'></span>
                                      Apply
                                    </>
                                  )}
                                </Button>
                              </Col>
                            </Row>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                    <Row className='mb-5'>
                      <Col md={6}>
                        <TopPartnerChartCard 
                          handlePartnerClicked={handleTopCountrySelected}
                          params={requestParams}
                          product_group={rawProductGroups}
                        />
                      </Col>
                      <Col md={6}>
                          <TopCommodityTableCard 
                          handleHSClicked={handleCommoditySelected}
                          params={requestParams}
                          product_group={rawProductGroups}/>
                      </Col>
                    </Row>
                    <Row className='mb-5'>
                      <Col>
                        <ByProductLineChartCard params={requestParams} product_group={rawProductGroups}/>
                      </Col>
                    </Row>
                    <Row className='mb-5'>
                      <Col>
                        <CommodityLineChartCard params={requestParams} product_group={rawProductGroups}/>
                      </Col>
                    </Row>
                    <Row className='mb-5'>
                      <Col>
                        <p className='text-muted'>
                          This work was in part funded by Development Account Project <a href="https://www.unescap.org/projects/nature-based-solutions-climate-action/project-streams" target="_blank" rel="noopener noreferrer">“Enhancing investments for equitable and accelerated climate action in the post-COVID-19 recovery"</a>
                        </p>
                      </Col>
                    </Row>
                    <Row className='mb-5'>
                      <Col className='d-flex flex-row gap-3'>
                        <FacebookShareButton url={shareUrl}>
                          <FacebookIcon size={32} round />
                        </FacebookShareButton>

                        <TwitterShareButton url={shareUrl} title={title}>
                          <XIcon  size={32} round />
                        </TwitterShareButton>

                        <LinkedinShareButton url={shareUrl} title={title}>
                          <LinkedinIcon size={32} round />
                        </LinkedinShareButton>

                        <WhatsappShareButton url={shareUrl} title={title}>
                          <WhatsappIcon size={32} round />
                        </WhatsappShareButton>

                        <EmailShareButton url={shareUrl} subject={title} body="Check out this link:">
                          <EmailIcon size={32} round />
                        </EmailShareButton>
                      </Col>
                    </Row>
                  </Content>
                </div>
                <FooterWrapper />
              </div>
            </div>
          </div>
        </div>
        <ScrollTop />
      </PageDataProvider>
      <CommodityDetailModal 
            params={modalParam} 
            handleDisplayToggle={handleToggleModal}
            product_group={rawProductGroups}/>
    </>
  )
}

export default WEFDashboardPage